import React from 'react';

import i18 from '../../../../i18';

class RowUnprocessed extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            supplierNameChecked: false,
            itemNameChecked: false,
            itemName: props.invoiceItem.name || '',

            positionNumberCountryChecked: false,
            positionNumberCountry: props.invoice.positionNumberCountry || '',

            invoice: props.invoice || '',

            orderNumberStatChecked: false,
            orderNumberStat: props.invoice.orderNumberStat || '',

            mainBookkeepingNumber: '',
            vatCollectorId: '',
            vatDegree: '',
            savingRule: false,
        };
    }

    getSupplierName = () => {
        const {invoice} = this.props;

        if (
            invoice
            && invoice.supplier
            && invoice.supplier.name
        ) {
            return invoice.supplier.name;
        }

        return '';
    };

    getVatPercentage = () => {
        const {invoiceItem} = this.props;
        const value = Number(invoiceItem.vatPercentage) * 100;

        return Number.isNaN(value)
            ? null
            : value;
    };

    onElementChange = (event) => {
        const {
            name,
            type,
            checked,
            value,
        } = event.target;

        this.setState({
            [name]: type === 'checkbox'
                ? checked
                : value,
        });
    };

    validate = () => {
        const {
            mainBookkeepingNumber,
            vatCollectorId,
            vatDegree,
            supplierNameChecked,
            itemNameChecked,
            positionNumberCountryChecked,
            orderNumberStatChecked,
        } = this.state;

        if (
            !supplierNameChecked
            && !itemNameChecked
            && !positionNumberCountryChecked
            && !orderNumberStatChecked
        ) {
            this.props.notifyError(
                'A szállítót, a tételt, az országos pozíciószámot vagy a statisztikai rendelési számot muszáj megjelölni.',
            );

            return false;
        }

        if (
            !mainBookkeepingNumber
            || !vatCollectorId
            || !vatDegree
        ) {
            this.props.notifyError(
                'Kérjük, ellenőrizze a kötelező mezőket: '
                + 'Fők. szám, Gyűjtő kód, ÁFA fők. szám.',
            );

            return false;
        }

        return true;
    };

    buildRuleData = (type) => {
        return {
            supplier_name: this.state.supplierNameChecked ? this.getSupplierName() : '',
            item_name: this.state.itemNameChecked ? this.state.itemName : '',
            position_number_country: this.state.positionNumberCountryChecked ? this.state.positionNumberCountry : null,
            order_number_stat: this.state.orderNumberStatChecked ? this.state.orderNumberStat : null,
            vat: this.getVatPercentage(),
            type,
            main_bookkeeping_number: this.state.mainBookkeepingNumber,
            vat_collector_id: this.state.vatCollectorId,
            vat_degree: this.state.vatDegree,
        };
    };

    createRule = async (type) => {
        if (
            this.state.savingRule
            || this.props.creatingRule
        ) {
            return;
        }

        if (!this.validate()) {
            return;
        }

        this.setState({
            savingRule: true,
        });

        try {
            await this.props.onCreateRule(
                null,
                this.buildRuleData(type),
            );
        } finally {
            this.setState({
                savingRule: false,
            });
        }
    };

    deleteInvoiceItem = () => {
        this.props.deleteInvoiceItem(
            this.props.invoiceItem._internalId,
        );

        this.props.notifyError(
            'A tétel törölve lett a kimenetből.',
        );
    };

    deleteInvoice = () => {
        this.props.deleteInvoice(
            this.props.invoice._internalId,
        );

        this.props.notifyError(
            'A számla törölve lett a kimenetből.',
        );
    };

    renderVatCollectorOptions = () => {
        return (this.props.vatCollectorCodes || []).map(
            (vatCollectorCode) => (
                <option
                    value={vatCollectorCode.id}
                    key={vatCollectorCode.id}
                >
                    {vatCollectorCode.code}
                    &nbsp;({vatCollectorCode.title})
                </option>
            ),
        );
    };

    renderRuleTextField = ({
                               name,
                               value,
                               checked,
                               label,
                               isSaving,
                               className = 'no-border-underline-text-input',
                           }) => {
        const id = `${name}-${this.props.keyIndex}`;

        return (
            <React.Fragment>
                <input
                    id={id}
                    name={`${name}Checked`}
                    checked={checked}
                    type="checkbox"
                    onChange={this.onElementChange}
                    disabled={isSaving}
                />

                <label htmlFor={id} className="sr-only">
                    {label}
                </label>

                <input
                    name={name}
                    value={value}
                    onChange={this.onElementChange}
                    className={className}
                    type="text"
                    disabled={isSaving}
                />
            </React.Fragment>
        );
    };

    render() {
        const {
            invoice,
            supplierNameChecked,
            itemNameChecked,
            itemName,
            positionNumberCountryChecked,
            positionNumberCountry,
            orderNumberStatChecked,
            orderNumberStat,
            mainBookkeepingNumber,
            vatCollectorId,
            vatDegree,
            savingRule,
        } = this.state;

        const isSaving = savingRule
            || this.props.creatingRule;

        const vatPercentage = this.getVatPercentage();

        return (
            <tr>
                <td>{invoice.invoiceNumber || '-'}</td>
                <td>
                    <input
                        id={`supplierName-${this.props.keyIndex}`}
                        name="supplierNameChecked"
                        checked={supplierNameChecked}
                        type="checkbox"
                        onChange={this.onElementChange}
                        disabled={isSaving}
                    />

                    <label htmlFor={`supplierName-${this.props.keyIndex}`}>
                        &nbsp;&nbsp;
                        {this.getSupplierName() || '-'}
                    </label>
                </td>
                <td>{invoice.customer.name || '-'}</td>
                <td>
                    {this.renderRuleTextField({
                        name: 'itemName',
                        value: itemName,
                        checked: itemNameChecked,
                        label: 'Tétel megjelölése',
                        isSaving,
                    })}
                </td>

                <td>
                    {this.renderRuleTextField({
                        name: 'positionNumberCountry',
                        value: positionNumberCountry,
                        checked: positionNumberCountryChecked,
                        label: 'Országos pozíciószám megjelölése',
                        isSaving,
                    })}
                </td>

                <td>
                    {this.renderRuleTextField({
                        name: 'orderNumberStat',
                        value: orderNumberStat,
                        checked: orderNumberStatChecked,
                        label: 'Statisztikai rendelési szám megjelölése',
                        isSaving,
                    })}
                </td>

                <td>
                    <input
                        name="mainBookkeepingNumber"
                        value={mainBookkeepingNumber}
                        onChange={this.onElementChange}
                        className="bordered-input"
                        type="text"
                        disabled={isSaving}
                    />
                </td>
                <td>{vatPercentage === null ? '-' : `${vatPercentage}%`}</td>
                <td>
                    <select
                        value={vatCollectorId}
                        name="vatCollectorId"
                        onChange={this.onElementChange}
                        className="minimal form-control"
                        disabled={isSaving}
                    >
                        <option value="">
                            Kérjük válasszon
                        </option>

                        {this.renderVatCollectorOptions()}
                    </select>
                </td>
                <td>
                    <input
                        name="vatDegree"
                        onChange={this.onElementChange}
                        value={vatDegree}
                        className="bordered-input"
                        type="text"
                        disabled={isSaving}
                    />
                </td>

                <td>
                    <button
                        type="button"
                        onClick={() => this.createRule('final')}
                        title={i18.SUPPLIER._createRulesAndProcess}
                        className="btn btn-link p-0 mr-2"
                        disabled={isSaving}
                    >
                        <i
                            className="fa fa-dot-circle-o"
                            aria-hidden="true"
                        />
                    </button>

                    <button
                        type="button"
                        onClick={() => this.createRule('temporarily')}
                        title={i18.SUPPLIER._oneTimeProcessing}
                        className="btn btn-link p-0 mr-2"
                        disabled={isSaving}
                    >
                        <i
                            className="fa fa-check-circle"
                            aria-hidden="true"
                        />
                    </button>

                    <button
                        type="button"
                        onClick={this.deleteInvoiceItem}
                        title="Tétel törlése a kimenetből"
                        className="btn btn-link p-0 mr-2"
                        disabled={isSaving}
                    >
                        <i
                            className="fa fa-trash-o"
                            aria-hidden="true"
                        />
                    </button>

                    <button
                        type="button"
                        onClick={this.deleteInvoice}
                        title="Számla törlése a kimenetből"
                        className="btn btn-link p-0"
                        disabled={isSaving}
                    >
                        <i
                            className="fa fa-trash"
                            aria-hidden="true"
                        />
                    </button>
                </td>
            </tr>
        );
    }
}

export default RowUnprocessed;


// WEBPACK FOOTER //
// ./src/components/supplier/steps/assignment/RowUnprocessed.js